import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=89f6660c&"
import script from "./Carousel.ts?vue&type=script&lang=ts&"
export * from "./Carousel.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports